import classNames from 'classnames';
import RatingStars from '../../Molecules/RatingStars';
import Text from '../../Atoms/Text';
import Image from '../../Atoms/Image';
import Title from '../../Atoms/Title';

interface Props {
  rating: number;
  info: string;
  logoSrc: string;
  className?: string;
}

function Rating({
  rating,
  info,
  logoSrc,
  className
}: Props) {
  return (
    <div
      className={classNames([
        'w-full @container',
        className
      ])}
    >
      <div className="flex flex-col items-center justify-between gap-7 rounded-xl border-[1.5px] border-sl-gray-light bg-white p-7 shadow-xl @xs:flex-row">
        <Title as="h4" size={2}>
          <span>{rating}</span>
        </Title>
        <div className="flex flex-col items-center gap-3.5">
          <RatingStars
            rating={rating}
            className="text-3xl text-sl-yellow"
          />
          <div className="flex flex-row items-center justify-between gap-3.5">
            <Text font="circular">
              <span className="text-sm">{info}</span>
            </Text>
            <div className="w-16">
              <Image src={logoSrc} className="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Rating;
